import {
  useAgentBackupChangeNameBackupAgentChangeNamePostMutation,
  useAgentBackupRestoreBackupAgentRestorePostMutation,
  useCreateAgentBackupBackupAgentCreatePostMutation,
  useCreateAgentBackupBackupAgentListGetQuery,
  useDeleteAgentBackupBackupAgentDeleteDeleteMutation,
} from '@shared/api';

export const useAgentBackups = (agentId: number, onRestoreSuccess?: () => void | Promise<void>) => {
  const { data, isLoading, isError, refetch } = useCreateAgentBackupBackupAgentListGetQuery(
    { agentId },
    {
      skip: !agentId,
      refetchOnMountOrArgChange: true,
    },
  );

  const [createBackupMutation] = useCreateAgentBackupBackupAgentCreatePostMutation();
  const [renameBackupMutation] = useAgentBackupChangeNameBackupAgentChangeNamePostMutation();
  const [restoreBackupMutation] = useAgentBackupRestoreBackupAgentRestorePostMutation();
  const [deleteBackupMutation] = useDeleteAgentBackupBackupAgentDeleteDeleteMutation();

  const createBackup = async (name: string) => {
    await createBackupMutation({
      bodyCreateAgentBackupBackupAgentCreatePost: {
        agent_id: agentId,
        name,
      },
    }).unwrap();
  };

  const renameBackup = async (backupId: number, name: string) => {
    await renameBackupMutation({
      backupId,
      bodyAgentBackupChangeNameBackupAgentChangeNamePost: {
        new_name: name,
      },
    }).unwrap();
  };

  const restoreBackup = async (backupId: number) => {
    await restoreBackupMutation({
      bodyAgentBackupRestoreBackupAgentRestorePost: {
        backup_id: backupId,
      },
    }).unwrap();

    await onRestoreSuccess?.();
  };

  const deleteBackup = async (backupId: number) => {
    await deleteBackupMutation({
      backupId,
    }).unwrap();
  };

  return {
    backups: data ?? [],
    isLoading,
    isError,
    refetch,
    createBackup,
    renameBackup,
    restoreBackup,
    deleteBackup,
  };
};
